export const VERIFY_BY_GS1_LINK = "https://www.gs1pl.org/uslugi-i-narzedzia/verified-by-gs1";
